import React from "react";
import {BadgeProps} from "../types";

const badge = ({badgeText, badgeSrc, textClassName}: BadgeProps) => {
    return (
        <>
            <img src={badgeSrc} alt={badgeText}/>
            <p className={textClassName}>{badgeText}</p>
        </>
    )
}


export default badge;
